<hr style="margin-top: 0px; margin-bottom: 15px;">
<div class="container-fluid">

  <p-confirmDialog key="cd1" #cd1>
    <ng-template #footer>
        <button type="button" class="btn btn-success" (click)="cd1.onAccept()">Continue</button>
        <button type="button" class="btn btn-basic" (click)="cd1.onReject()">Cancel</button>
    </ng-template>
  </p-confirmDialog>

  <div style="display: flex; gap: 10px;">

    <div class="review-left-col" style="min-width: 350px; max-width: 350px; display: flex; flex-direction: column; min-height: 0;">
      <div style="display: block; margin-bottom: 8px; flex: none;">
        <label style="font-size: 17px; font-weight: 500; margin-bottom: 0;">SENSOR READINGS</label>
        <div style="display: flex; gap: 25px; margin-left: 20px;" class="text-center">
          <div style="display: block;">
            <div style="font-size: 12px;">Loaded</div>
            <div style="font-size: 12px;">{{ allAvailableReadings.length }}</div>
          </div>
          <div style="display: block;">
            <div style="font-size: 12px;">Selected</div>
            <div style="font-size: 12px;">{{ selectedSensorReadings.length }}</div>
          </div>
          <div style="display: block;">
            <div style="font-size: 12px;">Filtered</div>
            <div style="font-size: 12px;">{{ filteredSensorReadings.length }}</div>
          </div>
        </div>
      </div>

      <div style="border: 1px solid lightgray; flex: none;">
        <div style="padding: 10px; display: flex; justify-content: space-between; width: 100%; background-color: var(--kig-section-header-bg); height: 38px;">
          <label style="margin-top: -4px;">Date Range</label>
          <label style="font-size: 14px; color: black; margin-top: -2px;">{{ selectedDateRangeName }}</label>
        </div>

        <div style="display: flex; gap: 15px; padding-left: 10px;">
          <div class="form-group" style="margin-bottom: 13px; width: 96%;">
            <div style="display: flex; gap: 5; margin-top: 5px; margin-bottom: 2px;">
              <button (click)="datesUpdated('Last 4 hrs')" class="btn btn-sm" style="color: blue; height: 30px; margin-top: 4px; border: 1px solid lightgray; font-size: 14px;" type="button">Last 4 hrs</button>
              <button (click)="datesUpdated('Last 8 hrs')" class="btn btn-sm" style="color: blue; height: 30px; margin-top: 4px; border: 1px solid lightgray; font-size: 14px;" type="button">Last 8 hrs</button>
              <button (click)="datesUpdated('Last 12 hrs')" class="btn btn-sm" style="color: blue; height: 30px; margin-top: 4px; border: 1px solid lightgray; font-size: 14px;" type="button">Last 12 hrs</button>
              <button (click)="datesUpdated('Last 24 hrs')" class="btn btn-sm" style="color: blue; height: 30px; margin-top: 4px; border: 1px solid lightgray; font-size: 14px;" type="button">Last 24 hrs</button>
            </div>
             
            <input type="text" name="daterange" id="daterange" class="daterangeinput" style="height: 35px; width: 100%;" autocomplete="off"
                ngxDaterangepickerMd
                [(ngModel)]="selectedDateRange"
                [showCustomRangeLabel]="true"
                [alwaysShowCalendars]="true"
                [ranges]="ranges"
                [showRangeLabelOnInput]="true"
                [linkedCalendars]="true"
                [isInvalidDate] = "isInvalidDate"
                [showClearButton]="true"
                (datesUpdated)="datesUpdated('')"
                placeholder="Select Date Range"
                (rangeClicked)="setRangeSelected($event)"/>
          </div>
        </div>

        <div class="form-group" style="margin-bottom: 10px; padding-left: 10px;">
          <label for="TimeZone" style="font-weight: 500; font-size: 14px;">Displayed Timezone</label>
          <div style="font-size: 14px; margin-top: 2px; margin-bottom: 10px;">
              <input type="radio" [(ngModel)]="selectedTimeZone" name="Local" value="Local" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
              <label style="padding-left: 5px; padding-right: 20px;">Local</label>
              <input type="radio" [(ngModel)]="selectedTimeZone" name="Source" value="Source" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
              <label style="padding-left: 5px; padding-right: 20px;">Source</label>
              <input type="radio" [(ngModel)]="selectedTimeZone" name="UTC" value="UTC" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
              <label style="padding-left: 5px; padding-right: 20px;">UTC (GMT+0)</label>
          </div>
        </div>

        <div class="form-group" style="margin-bottom: 10px; padding-left: 10px;">
          <label for="readings" style="font-weight: 500; font-size: 14px;">Readings</label>

          <!-- GPS source indicator: per-sensor counts over the filtered readings -->
          <span style="margin-left: 8px; font-size: 13px;">
            <span *ngIf="gpsCounts.reading > 0"
                  title="Sensors using GPS from each reading"
                  style="margin-right: 10px;">
              <i class="fa-solid fa-location-dot" style="color: #d32f2f;"></i> - {{ gpsCounts.reading }}
            </span>
            <span *ngIf="gpsCounts.readings > 0"
                  title="Sensors whose GPS was derived from latitude/longitude reading types"
                  style="margin-right: 10px;">
              <i class="fa-solid fa-location-dot" style="color: #046dd6;"></i> - {{ gpsCounts.readings }}
            </span>
            <span *ngIf="gpsCounts.sensor > 0"
                  title="Sensors using GPS from the sensor's own location"
                  style="margin-right: 10px;">
              <i class="fa-solid fa-location-dot" style="color: #2e7d32;"></i> - {{ gpsCounts.sensor }}
            </span>
            <span *ngIf="gpsCounts.none > 0"
                  title="Sensors with no GPS coordinates available">
              <i class="fa-solid fa-location-dot" style="color: #b0b0b0;"></i> - {{ gpsCounts.none }}
            </span>
          </span>

          <div style="font-size: 14px; margin-top: 2px; margin-bottom: 10px;">
              <input type="checkbox" [(ngModel)]="showOriginalReadings" name="Original" value="showOriginalReadings" (ngModelChange)="selectedReadingSourceChanged()" style="cursor: pointer;"/>
              <label style="padding-left: 5px; padding-right: 25px;;">Original Values</label>
              <input type="checkbox" [(ngModel)]="showCalibratedReadings" name="Calibrated" value="showCalibratedReadings" (ngModelChange)="selectedReadingSourceChanged()" style="cursor: pointer;"/>
              <label style="padding-left: 5px; padding-right: 25px;">Calibrated Values</label>
          </div>
        </div>
  
      </div>

      <div #sensorsPanel class="grow-panel" [style.max-height.px]="sensorsPanelMaxHeightPx" style="border: 1px solid lightgray; flex: 1 1 0; min-height: 0; display: flex; flex-direction: column;">
        <div style="padding: 10px; display: flex; justify-content: space-between; width: 100%; background-color: var(--kig-section-header-bg); height: 38px; flex: none;">
          <label style="margin-top: -4px;">Sensors and Groups</label>
          <label style="font-size: 14px; color: black; margin-top: -2px;">Selected Sensors: {{ selectedSensors.length }}</label>
        </div>

        <div style="padding: 10px; flex: 1 1 0; min-height: 0; display: flex; flex-direction: column;">
          <div style="display: flex; border-bottom: 1px solid lightgray; flex: none;">
            <div (click)="toggleCheckedSensors()" style="margin-left: 12px; font-size: 24px; cursor: pointer;">▣</div>
            <i class="fa fa-search" style="margin: 12px 4px 0px 20px;" (click)="sensorSearchTextChanged()"></i>
            <form (ngSubmit)="sensorSearchTextChanged()">
                <input [(ngModel)]="searchSensorsText" placeholder="Search" style="height: 35px; width: 255px; margin-bottom: 10px; margin-top: 3px;" type="text" name="searchSensorsText" autocomplete="off" />
            </form>
          </div>

          <p-table #SensorsTable [columns]="SensorsAndGroupsCols" [value]="sensorsAndGroupsDisplayed" [scrollable]="true" scrollHeight="flex" >
              <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="i" class="data-acquisition">
                  <tr style="height: 30px;">
                      <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                          <!-- Group uses a native checkbox so it can show the indeterminate (partial) state -->
                          <input *ngIf="rowData.isSensorGroup" type="checkbox" name="grp{{i}}" [(ngModel)]="rowData.checked" [ngModelOptions]="{standalone: true}"
                                 [indeterminate]="rowData.indeterminate" (ngModelChange)="onGroupChecked(rowData)" style="cursor: pointer;" />
                          <p-checkbox *ngIf="rowData.isSensor" id="{{i}}" name="{{i}}" [(ngModel)]="rowData.checked" binary="true" (ngModelChange)="sensorSelectionChanged(rowData)" ></p-checkbox>
                      </td>

                      <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.isSensorGroup" style="color: #548235; cursor: pointer;" (click)="toggleGroupExpanded(rowData)">
                          <i class="fa" [ngClass]="rowData.expanded ? 'fa-chevron-down' : 'fa-chevron-right'" style="margin-right: 6px;"></i>
                          <i class="fa fa-folder" style="margin-right: 5px;"></i>
                          {{ rowData.name }} ({{ groupCheckedCount(rowData) }}/{{ rowData.count }})
                        </div>
                        <div *ngIf="rowData.isSensor" style="color: black;">
                          {{ rowData.name }}
                        </div>
                      </td>
                  </tr>

                  <!-- Expanded group: one indented row per member sensor -->
                  <ng-container *ngIf="rowData.isSensorGroup && rowData.expanded">
                      <tr *ngFor="let child of rowData.children" style="height: 28px;">
                          <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                              <p-checkbox name="grp{{i}}child{{child.id}}" [(ngModel)]="child.checked" [ngModelOptions]="{standalone: true}" binary="true" (ngModelChange)="onGroupChildChecked(rowData)" ></p-checkbox>
                          </td>
                          <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px; padding-left: 28px; color: black;">
                              {{ child.name }}
                          </td>
                      </tr>
                  </ng-container>
              </ng-template>
          </p-table>
        </div>

        <!-- Drag handle: slide up/down to resize the Sensors and Groups panel. -->
        <div (mousedown)="startSensorsResize($event)" title="Drag to resize"
             style="flex: none; height: 10px; cursor: ns-resize; display: flex; align-items: center; justify-content: center; background-color: #f0f0f0; border-top: 1px solid lightgray;">
          <div style="width: 40px; height: 3px; background-color: #b0b0b0; border-radius: 2px;"></div>
        </div>
      </div>

      <div *ngIf="selectedSensors.length > 0" class="grow-panel" [style.max-height.px]="readingTypesDisplayed.length * 43 + 130" style="border: 1px solid lightgray; flex: 1 1 0; min-height: 0; display: flex; flex-direction: column;">
        <div style="padding: 10px; display: flex; justify-content: space-between; width: 100%; background-color: var(--kig-section-header-bg); height: 38px; flex: none;">
          <label style="margin-top: -4px;">Reading Types</label>
          <span style="display: inline-flex; align-items: center; gap: 8px; margin-top: -2px;">
            <label style="font-size: 14px; color: black; margin-bottom: 0;">Selected Types: {{ selectedReadingTypes.length }}</label>
            <i class="fas fa-sync-alt" (click)="refreshReadings()"
               title="Reload the readings for the selected reading types"
               style="cursor: pointer; color: rgb(0, 123, 255);"></i>
          </span>
        </div>

        <div style="padding: 10px; flex: 1 1 0; min-height: 0; display: flex; flex-direction: column;">
          <div style="display: flex; border-bottom: 1px solid lightgray; flex: none;">
              <div (click)="toggleCheckedReadings()" style="margin-left: 12px; font-size: 24px; cursor: pointer;">▣</div>
              <i class="fa fa-search" style="margin: 12px 4px 0px 20px;" (click)="readingTypeSearchTextChanged()"></i>
              <form (ngSubmit)="readingTypeSearchTextChanged()">
                <input [(ngModel)]="searchReadingTypeText" placeholder="Search" style="height: 35px; width: 255px; margin-bottom: 10px; margin-top: 3px;" type="text" name="searchReadingTypeText" autocomplete="off" />
            </form>
          </div>
        
          <p-table #ReadingTypesTable [columns]="SensorReadingTypesCols" [value]="readingTypesDisplayed" [scrollable]="true" scrollHeight="flex">
              <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="i" class="data-acquisition">
                  <tr style="height: 30px;">
                      <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                          <p-checkbox id="{{i}}" name="{{i}}" [(ngModel)]="rowData.checked" binary="true" (ngModelChange)="readingTypeSelectionChanged(rowData)" ></p-checkbox>
                      </td>

                      <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.type }}
                      </td>

                      <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px; text-align: right;" title="Readings available for the selected sensors and date range">
                        <i *ngIf="getReadingCount(rowData.id) === undefined && readingCountsLoading" class="fa fa-spinner fa-spin" style="font-size: 11px; color: gray;"></i>
                        <span *ngIf="getReadingCount(rowData.id) !== undefined" style="font-size: 14px; color: #1c4966;">({{ getReadingCount(rowData.id) | number }})</span>
                      </td>
                  </tr>
              </ng-template>
          </p-table>
        </div>
      </div>
    </div>

    <div class="review-right-col">
      <div style="display: flex; width: 100%; height: 35px; align-items: center; justify-content: center;">
        <label style="font-size: 15px; margin-right: 5px;">Filter Sensor Readings </label>
        <input type="text" id="filterReadingValuesText" name="filterReadingValuesText" class="form-control" [(ngModel)]="filterReadingValuesText" (keyup.enter)="executeFilterReadingValues()" style="border-color: darkgray; margin-right: 5px; width: 500px; height: 35px;" required>
        <button type="button" class="btn btn-primary" (click)="executeFilterReadingValues()" style="height: 35px; padding-top: 2px;" >Search</button>
        <button type="button" class="btn btn-primary" (click)="clearFilterReadingText()" style="height: 35px; padding-top: 2px; margin-left: 6px;" >Clear</button>
      </div>
      <div style="display: flex; width: 100%; height: 20px; align-items: center; justify-content: center;">
        <label style="font-size: 12px; margin-right: 5px;">(Examples: "temp_f > 20 and temp_f <= 40, humidity < 50 or humidity > 80, ph >= 6.5)</label>
      </div>

      <tabset>
        <tab heading="Stats" [active]="activeTabIndex === 0" (selectTab)="onTabSelect(0)" class="tabset">
          <div style="padding: 10px;">
            <stats-readings-modal
              [sensors]="selectedSensors"
              [sensorReadings]="filteredSensorReadings"
              [sensorReadingTypes]="selectedReadingTypes"
              [includeCalValues]="showCalibratedReadings"
              [includeOrigValues]="showOriginalReadings">
            </stats-readings-modal>
          </div>
        </tab>

        <tab heading="Chart" [active]="activeTabIndex === 1" (selectTab)="onTabSelect(1)" class="tabset">
          <div style="padding: 10px;">

            <div style="margin: 10px; display: flex; gap: 12px; align-items: center; flex-wrap: wrap;">
              <button type="button" class="btn btn-primary" (click)="addNewTile()" [disabled]="!isChartFavoriteReadyToSave()"
                      title="Add another chart of the selected sensors and readings">Add New</button>

              <label style="margin: 0 0 0 10px;">Existing Charts</label>
              <div class="form-group" style="margin-bottom: 0; min-width: 280px;">
                <!-- Choosing a favorite only selects it: Open, Duplicate or Delete then act on it. -->
                <ng-select [items]="chartFavoritesNamesToDisplay"
                    bindLabel="name"
                    placeholder="Select Favorite"
                    [(ngModel)]="chartFavoriteChoice"
                    (focus)="updateChartFavoritesList(global.globalSwitch)"
                    groupBy="toGroupBy">
                </ng-select>
              </div>
              <button type="button" class="btn btn-success" (click)="openChosenFavorite()" [disabled]="chartFavoriteChoice == undefined">Open</button>
              <button type="button" class="btn btn-success" (click)="duplicateChosenFavorite()" [disabled]="chartFavoriteChoice == undefined">Duplicate</button>
              <button type="button" class="btn btn-danger" (click)="onDeleteChartFavoriteConfirm()" [disabled]="choiceFavorite == undefined || !choiceFavorite.userFeatureAccess['DeleteChart']">Delete</button>

              <div style="display: flex; align-items: center; gap: 6px; margin-left: auto;">
                <label style="margin: 0 6px 0 0;">Tile Size:</label>
                <input type="radio" [(ngModel)]="tileSize" name="tileSize" value="Small" (ngModelChange)="onTileSizeChange()" /> <label style="margin: 0 8px 0 0;">Small</label>
                <input type="radio" [(ngModel)]="tileSize" name="tileSize" value="Medium" (ngModelChange)="onTileSizeChange()" /> <label style="margin: 0 8px 0 0;">Medium</label>
                <input type="radio" [(ngModel)]="tileSize" name="tileSize" value="Large" (ngModelChange)="onTileSizeChange()" /> <label style="margin: 0;">Large</label>
              </div>
            </div>
            <hr>

            <div *ngIf="tiles.length === 0" class="text-muted" style="margin: 20px;">
              No charts are open. Select sensors and reading types, then choose Add New, or open an existing chart.
            </div>

            <!-- One tile per open chart. They all chart the left pane's selection. -->
            <div class="chart-tiles" [ngClass]="'size-' + tileSize" cdkDropList cdkDropListOrientation="mixed"
                 [cdkDropListData]="tiles" (cdkDropListDropped)="onTileDropped($event)">
              <chart-tile *ngFor="let tile of tiles; trackBy: trackTile"
                  cdkDrag [cdkDragDisabled]="tiles.length < 2"
                  [reorderable]="tiles.length > 1"
                  [tileKey]="tile.key"
                  [name]="tile.name"
                  [chartId]="tile.favorite?.id"
                  [darkBackground]="tile.darkBackground"
                  [canSave]="isChartFavoriteReadyToSave()"
                  (darkToggle)="onTileDarkToggle(tile)"
                  (exportRequested)="openChartExport(tile, exportChartTemplate)"
                  (saveRequested)="saveChartFavorite(tile, template)"
                  (closeRequested)="closeTile(tile)">
                <chart-readings-echart-modal
                  [sensors]="selectedSensors"
                  [sensorReadings]="filteredSensorReadings"
                  [sensorReadingTypes]="selectedReadingTypes"
                  [sensorGroups]="selectedSensorGroups"
                  [dateRangeStart]="echartDateRangeStart"
                  [includeCalValues]="showCalibratedReadings"
                  [includeOrigValues]="showOriginalReadings"
                  [darkBackground]="tile.darkBackground"
                  [savedChartDetails]="tile.savedChartDetails"
                  (chartDetailsChanged)="onEchartOptionsChanged()"
                  [chartFavoriteId]="tile.favorite?.id || 0"
                  [labelsEditable]="canEditTile(tile)"
                  [chartHeight]="tileChartHeight()"
                  [showYAxisSlider]="true">
                </chart-readings-echart-modal>
              </chart-tile>
            </div>
          </div>
        </tab>

        <tab heading="Table" [active]="activeTabIndex === 2" (selectTab)="onTabSelect(2)" class="tabset">
          <div style="padding: 10px;">
            <table-readings-modal
              [sensors]="selectedSensors"
              [sensorReadings]="filteredSensorReadings"
              [sensorReadingTypes]="selectedReadingTypes"
              [includeCalValues]="showCalibratedReadings"
              [includeOrigValues]="showOriginalReadings"
              [dateRange]="selectedDateRange"
              [timeZone]="selectedTimeZone"
              [timeZoneOffset]="selectedTimeZoneOffset">
            </table-readings-modal>
          </div>
        </tab>

        <tab heading="Map" [active]="activeTabIndex === 3" (selectTab)="onTabSelect(3)" class="tabset">
          <div style="padding: 10px;">
            <!-- Map favorites: the dropdown picks one and applies it to this whole page (left panel,
                 dates, time zone), then the saved view, popups and labels show on the map. -->
            <kig-map-favorite-bar
                [username]="username"
                [globalSwitch]="globalSwitch"
                [canSave]="isMapFavoriteReadyToSave()"
                [selected]="selectedMapFavorite"
                [rememberedId]="mapFavoriteIdToShow"
                [snapshot]="mapFavoriteSnapshot"
                (favoriteApplied)="applyMapFavorite($event)"
                (selectedChange)="onMapFavoriteSelected($event)">
            </kig-map-favorite-bar>

            <!-- Created only while this tab is open: a map created in a hidden tab has no size and
                 would fit its pins wrongly. -->
            <div style="margin-top: 8px;">
              <kig-map-favorite *ngIf="activeTabIndex === 3"
                  [height]="'calc(100vh - 330px)'"
                  [sensors]="selectedSensors"
                  [sensorReadings]="filteredSensorReadings"
                  [savedMapDetails]="mapSavedDetails"
                  [mapFavoriteId]="selectedMapFavorite?.id || 0"
                  [labelsEditable]="isMapFavoriteEditable()"
                  [username]="username"
                  (mapDetailsChanged)="onMapDetailsChanged($event)">
              </kig-map-favorite>
            </div>
          </div>
        </tab>

        <tab heading="Ask AI" [active]="activeTabIndex === 4" (selectTab)="onTabSelect(4)" class="tabset">
          <div style="padding: 10px;">
            <ai-readings-modal
              [sensors]="selectedSensors"
              [sensorReadings]="filteredSensorReadings"
              [sensorReadingTypes]="selectedReadingTypes"
              [includeCalValues]="showCalibratedReadings"
              [includeOrigValues]="showOriginalReadings">
            </ai-readings-modal>
          </div>
        </tab>
      
      </tabset>
    </div>

  </div>
</div>


<ng-template #loading>
  <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
  <span>Loading...</span>
</ng-template>


<ng-template #template>
  <div>
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Chart Favorite</h5>
    </div>
    <div class="modal-body">
        <div class="container-fluid">
            <div class="col-md-12">
                <form (ngSubmit)="addOrUpdateChartFavorite()" #favoriteNameEditor="ngForm">
                  <div class="form-group" style="margin-bottom: 20px;">
                      <label for="favoriteName">Favorite Name for Chart Settings*</label>
                      <input type="text" id="favoriteName" name="favoriteName" class="form-control" [(ngModel)]="favoriteName" required />
                  </div>

                  <div class="form-group" style="margin-bottom: 20px;">
                    <label for="ChartFavorite">Access Group*</label>
                    <ngx-select-dropdown [(ngModel)]="selectedUserGroup" [config]="userGroupconfig"
                      [options]="associatedUserGroups" name="ChartFavorite"></ngx-select-dropdown>
                  </div>

                  <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px; margin-bottom: 25px;" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
                  <button *ngIf="!isUpdate()" type="submit" class="btn btn-success col-xs-5 pull-right">Create</button>
                  <button *ngIf="isUpdate()" type="submit" class="btn btn-success col-xs-5 pull-right">Update</button>
                  <button type="button" class="btn btn-basic col-xs-5 pull-right" (click)="onFavoriteCancelButton()">Cancel</button>
                </form>
            </div>
        </div>
    </div>
  </div>
</ng-template>


<ng-template #exportChartTemplate>
  <div>
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Export Chart Data</h5>
    </div>
    <div class="modal-body">
        <div class="container-fluid">
            <div class="col-md-12">
                <form (ngSubmit)="exportChartDataWithOptions()" #exportChartNameEditor="ngForm">
                  <div class="form-group" style="margin-bottom: 20px;">
                      <label for="exportChartFilename">Filename*</label>
                      <input type="text" id="exportChartFilename" name="exportChartFilename" class="form-control" [(ngModel)]="exportChartFilename" required />
                  </div>

                  <button type="submit" class="btn btn-success col-xs-5 pull-right">Export</button>
                  <button type="button" class="btn btn-basic col-xs-5 pull-right" style="margin-bottom: 20px;" (click)="exportChartModalRef.hide()">Cancel</button>
                </form>
            </div>
        </div>
    </div>
  </div>
</ng-template>





